import React from 'react';
import { Link } from 'react-router';
import { Banner, Layout, Paragraph, ParagraphHeader } from '@axiom/ui';
import type { CandidateEngagementDetails } from '@axiom/validation';

export type EngagementsViewStateBannerWarmedYesProps = {
  engagement: CandidateEngagementDetails;
  name?: string;
};

export const EngagementsViewStateBannerWarmedYes: React.FC<
  EngagementsViewStateBannerWarmedYesProps
> = ({ engagement, name = 'ENGAGEMENTS_VIEW_STATE_BANNER_WARMED_YES' }) => {
  return (
    <Banner name={name} type="critical" impact="high">
      <Layout direction="vertical" verticalGutter="24px">
        <ParagraphHeader name="WARMED_YES_HEADER">
          Next Step: Share your profile
        </ParagraphHeader>
        <Paragraph name="WARMED_YES_MESSAGE_1">
          Axiom is preparing to share your profile with the client. When your
          profile is submitted, this opportunity will move to your Active
          Submissions.
        </Paragraph>
        <Paragraph name="WARMED_YES_MESSAGE_2">
          To make scheduling quick and easy for the client, provide plenty of
          open spots on your{' '}
          <Link
            to="../../profile/interview-availability"
            data-test="INTERVIEW_LINK"
          >
            interview availability calendar
          </Link>
          .
        </Paragraph>
      </Layout>
    </Banner>
  );
};
